import * as React from "react";
import Component from "../../../../AbstractComponent";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CompanyLookup from "../../../../Partials/Lookup/CompanyLookup";

import { Title } from "../../NewCoach/NewCoachComponents/Title";
import { Subtitle } from "../../NewCoach/NewCoachComponents/Subtitle";
export class NewChargeStep2 extends Component {
  render() {
    return (
      <div className="coach-content-wrapper">
        {this.props.coachType === "Receivable" &&
        <>
          <Title
            title={this.props.trans("coach/newcharge-step2/title-type/tobereceived")}
          />
          <Subtitle
            subtitle={this.props.trans("coach/newcharge-step2/subtitle-type/tobereceived")}
          />
        </>
        }
        {this.props.coachType === "Payable" &&
        <>
          <Title
            title={this.props.trans("coach/newcharge-step2/title-type/tobepaid")}
          />
          <Subtitle
            subtitle={this.props.trans("coach/newcharge-step2/subtitle-type/tobepaid")}
          />
        </>
        }
        {this.props.coachType === "registerIncomingInvoice" &&
        <>
          <Title
            title={this.props.trans("coach/newcharge-step2/title-type/registerincominginvoice")}
          />
          <Subtitle
            subtitle={this.props.trans("coach/newcharge-step2/subtitle-type/registerincominginvoice")}
          />
        </>
        }
        <div>
          <div>
            <div>
              <RadioGroup
                name="roleFilters"
                value={this.props.payerType}
                onChange={this.props.changePayerType}
                style={{width: "100%"}}
              >
                <FormControlLabel
                  value={"owner"}
                  label={this.props.trans("coach/step2/landlord-label")}
                  control={<Radio color="primary" />}
                  disabled={this.props.chargeType === "object"}
                />
                {this.props.payerType === 'owner' && (
                <div>
                  <div>
                    <CompanyLookup
                      {...this.props}
                      id="companyId"
                      name="companyId"
                      className="scroll-to-companyId"
                      isInlineBlock={true}
                      width="100%"
                      containerWidth="100%"
                      styleInModal={"styleInModal"}
                      autoSelectId={this.props.selectedOwner?.id}
                      ref="CompanyLookup"
                      floatingLabelText={this.trans("dropdown-searchlandlord-label")}
                      labelText={this.trans("dropdown-landlord-label")}
                      // buttonLabel={this.trans("dropdown-button-new-owner")}
                      // searchText={this.props.state.company ? this.props.state.company?.displayName : ""}
                      onSelect={this.props.selectCompany}
                      onClear={this.props.clearCompany}
                      noResultText={this.trans("dropdown-owner-notfound")}
                      error={this.props.ownerErrorMessage && this.props.ownerErrorMessage}
                      templateFor={"owner"}
                      filterAgency={true}
                      filterOwner={true}
                      hideClickThroughLink={true}
                      disableEntityCreation={true}
                      autoFocus={true}
                      disabled={this.props.chargeType === "object"}
                    />
                  </div>
                </div>
                )}
                <FormControlLabel
                  value={"agency"}
                  label={this.props.agencyName}
                  control={<Radio color="primary" />}
                  disabled={this.props.chargeType === "object"}
                />
              </RadioGroup>
            </div>
          </div>
        </div>
        {this.props.chargeType === "object" && (
          <div className="info-text-blue center">
            {this.trans("this_field_automatically_filled")}
          </div>
        )}
      </div>
    )
  }
}